import StorefrontPage from '../components/StorefrontPage'
import { ThemeProvider } from '../lib/themeProvider'
import './index.css'

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <StorefrontPage />
      </ThemeProvider>
    </div>
  )
}

export default App
